import { getSessionItem, removeSessionItem, setSessionItem } from './storageUtils';

const WITHDRAW_DATA_KEY = 'withdraw_data';

export const getWithdrawData = () => getSessionItem(WITHDRAW_DATA_KEY);
export const setWithdrawData = (data) => setSessionItem(WITHDRAW_DATA_KEY, data);
export const putWithdrawData = (key, data) => {
	const withdrawData = getWithdrawData();
	setSessionItem(WITHDRAW_DATA_KEY, { ...withdrawData, [key]: data });
};
export const mergeWithdrawData = (patch) => {
	const withdrawData = getWithdrawData();
	setSessionItem(WITHDRAW_DATA_KEY, { ...withdrawData, ...patch });
};
export const removeWithdrawData = (key) => {
	const withdrawData = getWithdrawData();
	if (!withdrawData) return;
	const { [key]: _removed, ...rest } = withdrawData;
	setSessionItem(WITHDRAW_DATA_KEY, rest);
};
export const clearWithdrawData = () => {
	removeSessionItem(WITHDRAW_DATA_KEY);
};
